module.exports = __webpack_public_path__ + "img/IMG_0204-15_FoamcoreMatted.8259d7cf.jpg";